/**
 * Embed-mode detection — true when Sage was loaded with `?embed=1`, i.e. the
 * Canopy portal is embedding it as the Insights module.
 *
 * Decided once, from the URL the page loaded with, and fixed for the life of
 * the page. Before this, App.tsx, useAppChrome.ts and InsightsPage.tsx each
 * re-read `window.location.search`, so any in-app link without `?embed=1`
 * (the admin pages' `<Link to="/admin/cubes">`, for one) flipped the iframe
 * into standalone chrome — a second sidebar and top bar inside the portal.
 * The reverse is held too: a later in-app URL that happens to carry `embed`
 * cannot switch a standalone tab into embed chrome. The portal always
 * (re)loads the iframe with `?embed=1`, and a standalone tab never has it.
 * The first call happens on the first render of App, before any navigation.
 * Falls back to false on any DOM error so the SPA always renders.
 */
let decided: boolean | null = null;

export function isEmbedMode(): boolean {
  if (decided === null) {
    try {
      decided = new URLSearchParams(window.location.search).has('embed');
    } catch {
      decided = false;
    }
  }
  return decided;
}

/** Test seam: forget the decision between cases. */
export function resetEmbedModeForTests(): void {
  decided = null;
}
